import _ from "lodash";
import moment from "moment-timezone";
import { sessionService } from 'redux-react-session';

export const normalizeData = (data = []) => _.clone(data, true);

export const leadWithZero = number =>
  number < 10 ? `0${number}` : `${number}`;

export const dateValueTypes = [
  "lastModified",
  "createdDate",
  "executedDate",
  // "projectedClosingDate",
];

export const convertObjectValues = values => {
  const dateValues = _.pick(values, dateValueTypes);

  const convertedDateValues = _.mapValues(
    dateValues,
    value => value && _.toNumber(value),
  );

  return {
    ...values,
    ...convertedDateValues,
  };
};

export const convertData = data => _.map(data, convertObjectValues);

export const formatDate = dateString => {
  // Handle null, undefined, or empty values
  if (!_.isNull(dateString) && !_.isUndefined(dateString) && !_.isEmpty(String(dateString))) {
    // Handle both numeric timestamps and string dates
    const localdate = Number.isNaN(Number(dateString)) 
      ? new Date(dateString) 
      : new Date(Number(dateString));
    
    const formatted = moment(localdate);
    
    // Validate before formatting
    if (!formatted.isValid()) {
      console.warn('Invalid date provided to formatDate');
      return '';
    }
    
    return formatted.format("MM-DD-YYYY");
  }
  return "";
};

export const formatDateAndTime = (dateString) => {
  // Handle null, undefined, or empty values
  if (!_.isNull(dateString) && !_.isUndefined(dateString) && !_.isEmpty(String(dateString))) {
    // Handle both numeric timestamps and string dates
    const localdate = Number.isNaN(Number(dateString)) 
      ? new Date(dateString) 
      : new Date(Number(dateString));
    
    const formatted = moment(localdate);
    
    // Validate before formatting
    if (!formatted.isValid()) {
      console.warn('Invalid date provided to formatDateAndTime');
      return '';
    }
    
    // Only show timezone if the input string contains timezone info (Z, +, or -)
    const hasTimezone = hasTimezoneInfo(dateString);
    const format = hasTimezone ? 'MM-DD-YYYY LT z' : 'MM-DD-YYYY LT';
    
    return formatted.format(format);
  }
  return '';
};
export const formatDateWithoutConversion = (dateString) => {
  if (!_.isNull(dateString) && !_.isEmpty(dateString)) {
    const date = _.split(dateString, '-');
    return _.concat(date[1], '-', date[2], '-', date[0]);
  }
  return '';
};

/**
 * Check if a date string contains timezone information
 * @param {string|number} dateValue - Date value to check
 * @returns {boolean} True if timezone info is present
 */
export const hasTimezoneInfo = (dateValue) => {
  return /Z|[+-]\d{2}:?\d{2}/.test(String(dateValue));
};

/**
 * Format date/time with calendar-style relative formatting (e.g., "Today at 2:30 PM")
 * Automatically detects timezone in input and shows timezone in output only if present
 * Handles invalid dates gracefully
 * 
 * @param {string|number|Date} dateTime - Date/time value to format
 * @returns {string} Formatted date string or empty string if invalid
 */
export const formatDateTimeWithTimezone = (dateTime) => {
  // Handle null, undefined, or empty values
  if (_.isNull(dateTime) || _.isUndefined(dateTime) || dateTime === '') {
    return '';
  }

  // Convert to moment and validate
  const m = moment(dateTime);
  if (!m.isValid()) {
    return '';
  }

  // Check if input contains timezone information
  const showTimezone = hasTimezoneInfo(dateTime);

  // Return calendar-formatted string with conditional timezone
  return m.calendar(null, showTimezone ? {
    sameDay: '[Today at] LT z',
    nextDay: '[Tomorrow at] LT z',
    nextWeek: 'dddd [at] LT z',
    lastDay: '[Yesterday at] LT z',
    lastWeek: '[Last] dddd [at] LT z',
    sameElse: 'MM/DD/YYYY [at] LT z',
  } : {
    sameDay: '[Today at] LT',
    nextDay: '[Tomorrow at] LT',
    nextWeek: 'dddd [at] LT',
    lastDay: '[Yesterday at] LT',
    lastWeek: '[Last] dddd [at] LT',
    sameElse: 'MM/DD/YYYY [at] LT',
  });
};

export const getValueWithoutLeadingSpaces = value =>
  value ? value.replace(/^\s+/g, "") : value;
export const getValueWithoutTrailingSpaces = value =>
  value ? value.replace(/\s+$/g, "") : "";

export const validateEmail = (email) => {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
}
